window.__mb_nativeConfig = {
    TestModule:{
        methods:['test'],
        constants:{}
    },
    FilePickerModule: {
        methods: [
            'pickFiles',
            'pickDirectory'
        ],
        constants: {}
    },
    SendMsgsModule: {
        methods: [
            'sendMsgs',
            'getTaskEstimatedTime'
        ],
        constants: {}
    },
    LoginModule: {
        methods: [
            'syncLoginInfo',
            'getWeworkAcccountInfo',
            'updateCurrentStaff',
            'tokenExpired',
            'logout'
        ],
        constants: {}
    },
    DeviceModule: {
        methods: ['getDeviceInfo'],
        constants: {}
    },
    StorageModule: {
        methods:['getMarkVersion','updateMarkVersion'],
        constants:{}
    }
};